export default "<section>\n    <dc-customer-sources></dc-customer-sources>\n</section>";